/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Line_Spacing_HelpInputs */

const en_options_display_line_spacing_help = /** @type {(inputs: Options_Display_Line_Spacing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spacing between lines (0-50%)`)
};

const fr_options_display_line_spacing_help = /** @type {(inputs: Options_Display_Line_Spacing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espacement entre les lignes (0-50%)`)
};

const de_options_display_line_spacing_help = /** @type {(inputs: Options_Display_Line_Spacing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeilenabstand (0-50%)`)
};

const it_options_display_line_spacing_help = /** @type {(inputs: Options_Display_Line_Spacing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spaziatura tra le righe (0-50%)`)
};

const ru_options_display_line_spacing_help = /** @type {(inputs: Options_Display_Line_Spacing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расстояние между строками (0-50%)`)
};

const es_options_display_line_spacing_help = /** @type {(inputs: Options_Display_Line_Spacing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaciado entre líneas (0-50%)`)
};

const zh_cn2_options_display_line_spacing_help = /** @type {(inputs: Options_Display_Line_Spacing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行间距（0-50%）`)
};

const ja_options_display_line_spacing_help = /** @type {(inputs: Options_Display_Line_Spacing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行間隔（0～50%）`)
};

const hi_options_display_line_spacing_help = /** @type {(inputs: Options_Display_Line_Spacing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पंक्तियों के बीच की दूरी (0-50%)`)
};

const pt_pt2_options_display_line_spacing_help = /** @type {(inputs: Options_Display_Line_Spacing_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaçamento entre linhas (0-50%)`)
};

/**
* | output |
* | --- |
* | "Spacing between lines (0-50%)" |
*
* @param {Options_Display_Line_Spacing_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_line_spacing_help = /** @type {((inputs?: Options_Display_Line_Spacing_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Line_Spacing_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_display_line_spacing_help(inputs)
	if (locale === "de") return de_options_display_line_spacing_help(inputs)
	if (locale === "it") return it_options_display_line_spacing_help(inputs)
	if (locale === "ru") return ru_options_display_line_spacing_help(inputs)
	if (locale === "es") return es_options_display_line_spacing_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_display_line_spacing_help(inputs)
	if (locale === "ja") return ja_options_display_line_spacing_help(inputs)
	if (locale === "hi") return hi_options_display_line_spacing_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_display_line_spacing_help(inputs)
	return en_options_display_line_spacing_help(inputs)
});